import React from "react";

// reactstrap components
import {
    Table,
    Badge,
    Button,
    DropdownMenu,
    DropdownItem,
    Modal,
    UncontrolledDropdown,
    DropdownToggle,
} from "reactstrap";
import UserDataService from "../../services/UserDataService";

class Users extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
        this.userDataService = new UserDataService();
    }

    handleBlockUser(user) {
        const body = {
            user_id: user.user_id,
            username: user.username,
            status: 2,
        };
        this.userDataService.update(body)
            .then((data) => {
                if (data.header.status_code !== 200) {
                    let errorMessages = []
                    data?.data?.map((d) => {
                      errorMessages.push(d?.error_message)
                    })
                    this.setState({ errorMessages: errorMessages })
                } else {
                    this.props.setSuccessMessage("User berhasil diblokir")
                    this.props.fetchData()
                }
            });
    }

    toggleModal = (user) => {
        this.props.toggleModal("formModal", "edit", user)
    }

    toggleModals = (state, user) => {
        this.setState({
          [state]: !this.state[state],
          userToDisabled: user,
        });
    };

    onDisableModalOpened = (user) => {
        this.setState({
            userToDisabled: user,
        });
    }

    handleDisableUser() {
        this.userDataService.disable(this.state.userToDisabled)
            .then((data) => {
                this.handleResponse(data, "User berhasil dinonaktifkan");
            });
    }

    handleResponse(data, successMessage) {
        if (data.header.status_code !== 200) {
            let errorMessages = []
            data?.data?.map((data) => {
              errorMessages.push(data?.error_message)
            })
            this.setState({ errorMessages: errorMessages })
        } else {
            this.toggleModals("notificationModal")
            this.props.setSuccessMessage(successMessage)
            this.setState({ currentUser: {}})
            this.props.fetchData()
        }
    }

    render() {
        const userStatuses = ['Aktif', 'Tidak aktif', 'Diblokir'];
        return (
            <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                <tr>
                    <th scope="col">Username</th>
                    <th scope="col">Roles</th>
                    <th scope="col">Warehouse</th>
                    <th scope="col">Status</th>
                    <th scope="col" />
                </tr>
                </thead>
                <tbody>
                {this.props.users.map((user) => (
                    <tr style={{cursor: 'pointer'}}>
                    <th scope="row" onClick={() => this.toggleModal(user)}>
                        {user.username}
                    </th>
                    <td onClick={() => this.toggleModal(user)}>
                    {(user.Roles && user.Roles.length > 0 ? user.Roles : [user.role_name?.toLowerCase()]).map((role, index) => (
                        <span key={index}>
                        {role}
                        {index < user.Roles.length - 1 && <br />}
                        </span>
                    ))}
                    </td>
                    <td onClick={() => this.toggleModal(user)}>
                        {(this.props.warehouses.find(warehouse =>
                            warehouse.warehouse_id === user.warehouse_id
                        ) || {}).warehouse_name ?? '-'}
                    </td>
                    <td onClick={() => this.toggleModal(user)}>
                        <Badge color="" className="badge-dot mr-4">
                        <i className={user.status === 0 ? "bg-info" : "bg-warning"} />
                        {userStatuses[user.status]}
                        </Badge>
                    </td>
                    <td className="text-right">
                        <UncontrolledDropdown>
                        <DropdownToggle
                            className="btn-icon-only text-light"
                            role="button"
                            size="sm"
                            color=""
                            onClick={(e) => e.preventDefault()}
                        >
                            <i className="fas fa-ellipsis-v" />
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-arrow" right>
                            <DropdownItem
                            onClick={() => this.toggleModal(user)}
                            >
                            Ubah
                            </DropdownItem>
                            <DropdownItem
                            onClick={() => this.toggleModals("notificationModal", user)}
                            >
                            Nonaktifkan
                            </DropdownItem>
                            {((localStorage.getItem('user_roles') || '').toLowerCase().split(',').map(r => r.trim()).includes('admin')) && (
                                <DropdownItem
                                    onClick={() => this.handleBlockUser(user)}
                                >
                                    Blokir
                                </DropdownItem>
                            )}
                        </DropdownMenu>
                        </UncontrolledDropdown>
                    </td>
                    </tr>
                ))}
                </tbody>
                <Modal
                    className="modal-dialog-centered modal-danger"
                    contentClassName="bg-gradient-danger"
                    isOpen={this.state.notificationModal}
                    // onOpened={() => this.onDisableModalOpened(user)}
                    toggle={() => this.toggleModals("notificationModal")}
                    >
                    <div className="modal-header">
                        <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleModals("notificationModal")}
                        >
                        <span aria-hidden={true}>×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="py-3 text-center">
                        <i className="ni ni-bell-55 ni-3x" />
                        <h4 className="heading mt-4">Anda akan mengnonaktifkan user berikut</h4>
                        <p>
                            Username <b>{this.state.userToDisabled?.username}</b>
                        </p>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <Button
                        className="text-white ml-auto"
                        color="link"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleModal("notificationModal")}
                        >
                        Batal
                        </Button>
                        <Button 
                        className="btn-white" 
                        color="default" 
                        type="button"
                        onClick={() => this.handleDisableUser()} 
                        >
                        Nonaktifkan
                        </Button>
                    </div>
                </Modal>
            </Table>

        )
    };
}

export default Users;
